var map = {
	"./banks/cimb.png": 21,
	"./banks/citibank.png": 22,
	"./banks/dbs.png": 23,
	"./banks/maybank.png": 24,
	"./banks/ocbc.png": 25,
	"./banks/rhb.png": 26,
	"./banks/scb.png": 27,
	"./banks/uob.png": 28,
	"./banner/1.jpg": 29,
	"./banner/2.jpg": 30,
	"./banner/3.jpg": 31,
	"./banner/4.jpg": 32,
	"./banner/5.jpg": 33,
	"./check.svg": 34,
	"./click.svg": 35,
	"./cover/1.jpg": 36,
	"./cover/2.jpg": 37,
	"./cover/3.jpg": 38,
	"./cover/4.png": 39,
	"./homepage.png": 40,
	"./icons/dribbble.svg": 41,
	"./icons/facebook.svg": 42,
	"./icons/github.svg": 43,
	"./icons/gplus.svg": 44,
	"./icons/twitter.svg": 45,
	"./lenders.svg": 46,
	"./logo-footer.svg": 47,
	"./logo.svg": 48,
	"./mail-strip.png": 49,
	"./navigator.svg": 50,
	"./people/1.jpg": 51,
	"./people/2.jpg": 52,
	"./people/3.jpg": 53,
	"./people/4.jpg": 54
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 20;